export const getImageUrl = (path) => {
    if (!path) return '/images/placeholder.jpg';
    if (path.startsWith('http')) return path;
    return `https://fynho.com${path}`;
  };